function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 21,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff"
    },
    fillRule: "evenodd",
    d: "M22.471 20.999H8.712a.527.527 0 0 1-.53-.525V14.95h1.06v5h12.699V1.046H9.242v4.999h-1.06V.519c0-.288.238-.524.53-.524h13.759c.291 0 .528.236.528.524v19.955a.526.526 0 0 1-.528.525zM12.429 7.714a.523.523 0 0 1 .009-.743.533.533 0 0 1 .748.009l3.097 3.142a.523.523 0 0 1 .01.743l-3.107 3.151a.534.534 0 0 1-.748.009.524.524 0 0 1-.009-.744l2.226-2.258H.521a.528.528 0 0 1-.529-.525c0-.29.237-.526.529-.525h14.134l-2.226-2.259z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoLogin);
export default __webpack_public_path__ + "static/media/ico-login.596a80772870bb9a721377f23d842872.svg";
export { ForwardRef as ReactComponent };